import React from 'react'
import PropTypes from 'prop-types'
import { Form, InfoButton } from 'ui'

// FIXME: Duplicate (Step One, Step Three) code needs to be extracted in a module
export default function StepTwo({ step }) {
  return (
    <div className={`${step === 2 ? '' : 'd-none'}`}>
      <div className="section-headline container py-0">
        <div className="section-headline__content">
          <div className="row col-12">
            <div className="section-headline__text-container col-12 text-center">
              <h2 className="section-headline__headline">Kundennummer eingeben</h2>
              <div className="section-headline__subline">
                <strong>
                  Schritt {step++} von {step}
                </strong>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <p className="mb-1">
          Zur Prämienauszahlung bei erfolgreicher Empfehlung benötigen wir noch Ihre 1&1 Kundennummer:
        </p>
        <div className="d-flex mb-1">
          <Form.Input className="mt-2" name="value" placeholder="Kundennummer" required />
          <InfoButton
            className="ml-1 d-flex align-items-center"
            fade={false}
            text="Ihre Kundennummer wird verschlüsselt übertragen.
            Ihre Kundennummer finden Sie auf Ihren Rechnungen von 1&1."
          >
            <svg
              viewBox="0 0 10
            }0 100"
              className="icon icon--xsmall icon--color-secondary"
            >
              <use xlinkHref="#info-round-outline" />
            </svg>
          </InfoButton>
        </div>
        <div className="text-center">
          <Form.Button className="btn btn--small mx-auto mb-1" type="submit" text="Bestätigen" primary />
        </div>
        <a
          target="_blank"
          href="https://www.1und1.de/Datenschutz"
          className="link--dynamic link__text--gray text-center"
          rel="noreferrer"
        >
          <span className="link__text">
            <span>Hinweise zum Datenschutz</span>
          </span>
        </a>
      </div>
    </div>
  )
}

StepTwo.propTypes = {
  step: PropTypes.number
}
